import { computed, ref } from 'vue';
import { cloneObject } from 'utils';

const config = ref(payload.competitorAppConfig ? cloneObject(payload.competitorAppConfig) : null);

const applicationTypes = computed(() => config.value?.payload.applicationTypes);
const mediums = computed(() => config.value?.payload.mediums);
const technicalPropertyTypes = computed(() => config.value?.payload.technicalPropertyTypes);

function getApplicationType(applicationTypeCode) {
  return applicationTypes.value?.find((r) => r.code === applicationTypeCode);
}

function getMedium(mediumCode) {
  return mediums.value?.find((r) => r.code === mediumCode);
}

function getTechnicalPropertyType(technicalPropertyTypeCode) {
  return technicalPropertyTypes.value?.find((r) => r.code === technicalPropertyTypeCode);
}

export function useCompetitorAppConfig() {
  return {
    applicationTypes,
    mediums,
    technicalPropertyTypes,
    getApplicationType,
    getMedium,
    getTechnicalPropertyType,
  };
}
